import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) { navigate("/login"); return; }
        const session_id = decodeURIComponent(m[1]);
        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id });
                setUser(data);
                toast.success(`Welcome, ${data.name}`);
                navigate(data.role === "admin" ? "/admin" : "/dashboard", { replace: true });
            } catch (e) {
                toast.error("Google sign-in failed");
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-[60vh] grid place-items-center text-ink">
            <div className="h-display text-2xl text-gold animate-pulse" data-testid="auth-callback-loading">Crowning you…</div>
        </div>
    );
}
